import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

/**
 * Notification Center store — Story 92.2 Task 4.
 *
 * Open/close flag for the full-page Notification Center overlay. The overlay
 * itself is built in Story 92.3; 92.2 only flips the flag. The panel must
 * close before the overlay opens — wire that in the click handler, not in
 * the store, so stores stay side-effect-free.
 */
interface NotificationCenterStore {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

export const useNotificationCenterStore = create<NotificationCenterStore>()(
  devtools(
    (set) => ({
      isOpen: false,
      open: () => set({ isOpen: true }, false, 'notificationCenter/open'),
      close: () => set({ isOpen: false }, false, 'notificationCenter/close'),
    }),
    { name: 'notificationCenterStore' }
  )
);
